import { NodeType } from '../../node/types';
import { DEFAULT_LOCATION as loc } from '../../source/location';

export const createUndefinedLiteral = () => ({
  type: NodeType.UndefinedLiteral,
  loc,
});
